const Routes = {
    unAuthenticatedRoutes: [
        "/login",
        "/signup",
        "/forgot-password",
        "/new-password",
    ],
    both: [
        "/",
        "/404",       
    ],
    authenticatedRoutes: [
        "/profile",
        "/bookings",
        "/email-verification/success",
        "/email-verification/failed",
        "/ad/[eventUrl]", 
    ]
};

export default Routes;